import * as Actions from 'app/store/actions/ctm/landing.actions';

const initialState = {
	tunnelStationPoint: [],
	tunnelStationPointDesign: [],
    distanceFace:[],
    distanceInvert:[],
    measurementPoint:[],
	faceCamera:[],
	patternGroup:[],
	patternGroupDesign:[],
	noData:false,
	nearestTD:null,
	facePhoto:null,
	scanner:null,
	assessment:null,
	streeView:null,
	bMeasurement:null,
	stepManagement:null,
	processSimulator:null,
	tfasToken:null,
	rvp:[],
	tdProgress:null,
	liningInvertBandSegments: {
		lining_segments: [],
		invert_segments: [],
		lining_leading_edge_tunnel_dist: null,
		invert_leading_edge_tunnel_dist: null,
	},
	projectExtraURLs:[],
};

const ctmReducer = (state = initialState, action) => {
	switch (action.type) {
		case Actions.RESET_CTM: {
			return { ...initialState };
		}
		case Actions.ERROR_LIST_TUNNEL_STATION_POINT: {
			return {
				...state,
				noData:true,
			};
		}
		case Actions.PATTERN_GROUP_LIST: {
			return {
				...state,
				patternGroup:action.data,
			};
		}
		case Actions.PATTERN_GROUP_DESIGN_LIST: {
			return {
				...state,
				patternGroupDesign:action.data,
			};
		}
		case Actions.LIST_TUNNEL_STATION_POINT: {
			return {
				...state,
				tunnelStationPoint: action.data,
				noData:false,
			};
		}
		case Actions.LIST_TUNNEL_STATION_POINT_DESIGN: {
			return {
				...state,
				tunnelStationPointDesign: action.data,
				noData:false,
			};
		}
		case Actions.LIST_DISTANCE_FACE: {
			return {
				...state,
				distanceFace: action.data,
			};
		}
		
        case Actions.LIST_DISTANCE_INVERT: {
			return {
				...state,
				distanceInvert: action.data,
			};
		}
        case Actions.LIST_MEASUREMENT_POINT: {
			return {
				...state,
				measurementPoint: action.data,
			};
		}
		case Actions.GET_NEAREST_TD: {
			return {
				...state,
				nearestTD: action.data,
			};
		}
		case Actions.GET_NEXT_NEAREST_TD: {
			return {
				...state,
				nearestTD: action.data,
			};
		}
		case Actions.GET_PREV_NEAREST_TD: {
			return {
				...state,
				nearestTD: action.data,
			};
		}
		case Actions.REMOTE_VIEW_POINT: {
			return {
				...state,
				rvp: action.data,
			};
		}
		case Actions.GET_TFAS_ACCESS_TOKEN: {
			return {
				...state,
				tfasToken: action.data,
			};
		}
		case Actions.GET_CCTV_URL: {
			return {
				...state,
				faceCamera: action.cctv_url,
			};
		}
		case Actions.TUNNEL_DISTANCE_PROGRESS: {
			console.log('DEBUG TUNNEL_DISTANCE_PROGRESS: ', action.data);
			return {
				...state,
				tdProgress: action.data,
			};
		}
		case Actions.LINING_INVERT_BAND_SEGMENTS: {
			return {
				...state,
				liningInvertBandSegments: action.data,
			};
		}
		case Actions.GET_PROJECT_EXTRA_URLS: {
			return {
				...state,
				projectExtraURLs: action.data,
			};
		}

		default: {
			return state;
		}
	}
};

export default ctmReducer;
